package com.exura.features.publicplans.domain.api

import kotlinx.serialization.Serializable
import kotlin.js.JsName

@Serializable
@JsName("ChangeSharedPublicPlanRequest")
data class ChangeSharedPublicPlanRequest(
    @JsName("globalEntryId")
    val globalEntryId: String,

    @JsName("newPlanDefinitionId")
    val newPlanDefinitionId: String
)